import React, { useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Loading } from "react-loading-dot";
import "./Loader.scss";

const LoaderClip = ({ loading, className }) => {
  const [loaders, setLoader] = useState(false);

  const setLoaderStatus = (status) => {
    setLoader(status);
  };

  LoaderClip.defaultProps = {
    setLoaderStatus,
    loaders,
  };
  return (
    <div className={className}>
      <ClipLoader
        color={"#4676bf"}
        loading={loading}
        size={40}
        // css={override}
      />
    </div>
  );
};

export const LoaderDots = ({ isLoading = false, size = "10px" }) => {
  return isLoading ? (
    <div className="loaderCont z-[99999]">
      <Loading size={size} margin={"7px"} background={"#52547D"} />
    </div>
  ) : null;
};

export default LoaderClip;
